const users = {
    name: 'Users/UsersPage',
    path: '/users',
    icon: 'mdi-account-group',
    label: 'Users'
};

const dashboard = {
    name: 'Dashboard/DashboardPage',
    path: '/',
    icon: 'mdi-view-dashboard',
    label: 'Dashboard'
};

const foodflow = {
    name: 'FoodFlow/DashboardPage',
    path: '/foodflow',
    icon: 'mdi-food-apple',
    label: 'FoodFlow'
};

const sessions = {
    name: 'FoodFlow/SessionsPage',
    path: '/foodflow/sessions',
    icon: 'mdi-swap-horizontal',
    label: 'Sessions'
};

const suppliers = {
    name: 'FoodFlow/SuppliersPage',
    path: '/foodflow/suppliers',
    icon: 'mdi-handshake',
    label: 'Suppliers & Recipients'
};

const profile = {
    name: 'Dashboard/UserProfilePage',
    path: '/profile',
    icon: 'mdi-account',
    label: 'Profile'
};

const horizon = {
    name: 'Horizon',
    path: '/horizon',
    icon: 'mdi-sun-angle',
    label: 'Horizon',
    private: true,
    privateLabel: 'SA'
};

const pulse = {
    name: 'Pulse',
    path: '/pulse',
    icon: 'mdi-pulse',
    label: 'Pulse',
    private: true,
    privateLabel: 'SA'
};

const telescope = {
    name: 'Telescope',
    path: '/telescope',
    icon: 'mdi-telescope',
    label: 'Telescope',
    private: true,
    privateLabel: 'SA'
};

export const superAdmin = _ => {
    return [
        dashboard,
        foodflow,
        sessions,
        suppliers,
        users
    ];
};

export const admin = _ => {
    return [
        dashboard,
        foodflow,
        sessions,
        suppliers,
        users
    ];
};

export const user = _ => {
    return [
        dashboard,
        foodflow,
        sessions,
        suppliers,
    ];
};

export const bottomNavRoutes = _ => {
    return [
        profile,
        horizon,
        pulse,
        telescope,
    ];
};
